module.exports = __webpack_public_path__ + "UX28.png?af97091eb8eebd1d8ed6ed1d5c3964c7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX28.png
// module id = 77
// module chunks = 0